import {
  createSubscription,
  verifyCheckoutSession as verifyCheckoutSessionRequest,
  verifyUserSubscription,
} from '../../services/paymentService/paymentService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { trackInitiateCheckout } from '../../utils/gtm';

const PaymentController = (selectedPlan) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const clearAuthAndReload = () => {
    localStorage.removeItem('auth');
    localStorage.removeItem('haveSubscription');
    window.location.reload();
  };

  const handleError = (error) => {
    if (!error?.message) return;

    const firstWord = error.message.split(' ')[0];

    toast.error(t(firstWord), {
      onClose: () => {
        if (firstWord === 'Unauthorized,' || error.message === 'notFound') {
          clearAuthAndReload();
        }
      },
    });
  };

  const handlePayment = async () => {
    try {
      setLoading(true);

      const userId = localStorage.getItem('auth');

      if (!userId || !selectedPlan?.type) {
        setLoading(false);
        return;
      }

      trackInitiateCheckout({
        plan_id: selectedPlan.planId || selectedPlan.type,
        plan_name: selectedPlan.planName || selectedPlan.type,
        value: selectedPlan.price,
        currency: selectedPlan.currency || 'USD',
      });

      const subscription = await createSubscription(selectedPlan.type, userId);

      if (subscription?.checkoutUrl) {
        window.location.href = subscription.checkoutUrl;
        return;
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const userHaveSubscription = async () => {
    try {
      setLoading(true);

      const userId = localStorage.getItem('auth');

      if (!userId) {
        setLoading(false);
        return null;
      }

      const subscription = await verifyUserSubscription();
      return subscription;
    } catch (error) {
      handleError(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const verifyCheckoutSession = async (sessionId) => {
    try {
      setLoading(true);
      const response = await verifyCheckoutSessionRequest(sessionId);
      return response;
    } catch (error) {
      handleError(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handlePayment,
    userHaveSubscription,
    verifyCheckoutSession,
  };
};

export default PaymentController;